import { useEffect, useState } from 'react';
import { fetchPublishedChangelog } from '../../infrastructure/api/changelog.api';
import type { ChangelogPublicItem } from '../../application/types';

export function useChangelog() {
  const [items, setItems] = useState<ChangelogPublicItem[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    fetchPublishedChangelog()
      .then((list) => {
        if (!cancelled) {
          setItems(list);
          setIsError(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setIsError(true);
        }
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, isLoading, isError };
}
